import React, { lazy } from 'react';
import { Link } from 'react-router-dom';
import { Mail, Clock } from 'lucide-react';
import { openCookiePreferences } from '../../utils/consent';
export default function Footer() {
  return <footer className="bg-primary text-white pt-12 pb-6" data-id="element-53" data-mp="alno3kn7h3wi">
      <div className="container mx-auto px-4" data-id="element-54" data-mp="ao9uvi29vfdo">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8" data-id="element-55" data-mp="5nvridbm8tlz">
          {/* About */}
          <div data-id="element-56" data-mp="p16r5u38uz8">
            <div className="flex items-center mb-4" data-id="element-57" data-mp="pke5sm440z0">
              <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/hDXV1rDXM1m2ARqkQ9Hg8F/Medico_Favicon.png" alt="Medicolegal Psychiatry Expert Witness Logo" className="h-10 w-auto mr-3" loading="lazy" data-id="element-58" data-mp="3s2x6tjy77b6p" />
              <h3 className="font-serif text-xl font-bold" data-id="element-59" data-mp="3e2w562a3zzq6">
                Medicolegal Psychiatry
              </h3>
            </div>
            <p className="mb-4 text-sm leading-relaxed" data-id="element-60" data-mp="394ucqqqsmo21">
              Medico-Legal Psychiatry is led by Dr Imtiaz Syed, a GMC registered
              Psychiatrist and accredited Expert Witness. With over 20 years of
              clinical experience, we are committed to providing clear,
              impartial, and evidence-based psychiatric assessments across the
              UK.
            </p>
            <p className="text-sm leading-relaxed" data-id="element-61" data-mp="2gckp1odlyap4">
              Our services are guided by the principles of Clarity, Compassion,
              and Expertise, ensuring reliability and professionalism in every
              case.
            </p>
          </div>
          {/* Opening Hours */}
          <div data-id="element-62" data-mp="2u1uwcr3dk8lc">
            <h3 className="font-serif text-xl font-bold mb-4 flex items-center" data-id="element-63" data-mp="2u24r0rzd73xd">
              <Clock className="mr-2 h-5 w-5" data-id="element-64" data-mp="2z0y2kev3ckuw" />
              Opening Hours
            </h3>
            <ul className="space-y-2 text-sm" data-id="element-65" data-mp="1inhnasda5xpd">
              <li className="flex justify-between" data-id="element-66" data-mp="1ipu3p13e400b">
                <span data-id="element-67" data-mp="1nn4050p75bxn">Monday:</span>
                <span data-id="element-68" data-mp="1no5fhhd8wkl6">9:00am – 5:00pm</span>
              </li>
              <li className="flex justify-between" data-id="element-69" data-mp="13kzgkrw4vczj">
                <span data-id="element-70" data-mp="13mkaqgejctwv">Tuesday:</span>
                <span data-id="element-71" data-mp="zimdycconv6z">9:00am – 5:00pm</span>
              </li>
              <li className="flex justify-between" data-id="element-72" data-mp="zli9ju1267s9">
                <span data-id="element-73" data-mp="ure2zbvpg1rp">Wednesday:</span>
                <span data-id="element-74" data-mp="uqba4yetnp95">9:00am – 5:00pm</span>
              </li>
              <li className="flex justify-between" data-id="element-75" data-mp="ps9pwa5ntjw3">
                <span data-id="element-76" data-mp="ku895vvphwns">Thursday:</span>
                <span data-id="element-77" data-mp="kvaza1l7fv2n">9:00am – 5:00pm</span>
              </li>
              <li className="flex justify-between" data-id="element-78" data-mp="fv55ofvdjyhx">
                <span data-id="element-79" data-mp="fudfxlogkuzk">Friday:</span>
                <span data-id="element-80" data-mp="fxhunczjv94h">9:00am – 5:00pm</span>
              </li>
              <li className="flex justify-between" data-id="element-81" data-mp="bucx7oubtxmp">
                <span data-id="element-82" data-mp="6uqfb23jzt7k">Saturday:</span>
                <span data-id="element-83" data-mp="6vs409dhse7r">9:00am – 1:00pm</span>
              </li>
              <li className="flex justify-between" data-id="element-84" data-mp="267b0hohlzu0j">
                <span data-id="element-85" data-mp="2672qq5gs94tk">Sunday:</span>
                <span data-id="element-86" data-mp="218hwqns4jhdk">Closed</span>
              </li>
            </ul>
          </div>
          {/* Quick Links */}
          <div data-id="element-87" data-mp="28sitj4k2q7ht">
            <h3 className="font-serif text-xl font-bold mb-4" data-id="element-88" data-mp="28ssh6lhnc2kc">Quick Links</h3>
            <ul className="space-y-2 text-sm" data-id="element-89" data-mp="2dqtzv5b5tzva">
              <li data-id="element-90" data-mp="2dpizzgku5c9g">
                <Link to="/about" className="hover:text-secondary transition-colors" data-id="element-91" data-mp="2dp0xi27ky1t3">
                  About Dr. Syed
                </Link>
              </li>
              <li data-id="element-92" data-mp="1pt4vaafbaali">
                <Link to="/services" className="hover:text-secondary transition-colors" data-id="element-93" data-mp="1ptod7r4yoyzj">
                  Our Services
                </Link>
              </li>
              <li data-id="element-94" data-mp="1zr2qxizi39o5">
                <Link to="/faq" className="hover:text-secondary transition-colors" data-id="element-95" data-mp="1zqj7fxu7cd80">
                  FAQs
                </Link>
              </li>
              <li data-id="element-96" data-mp="3b5y759dspj6t">
                <Link to="/contact" className="hover:text-secondary transition-colors" data-id="element-97" data-mp="3b8keb7wrxwoi">
                  Contact Us
                </Link>
              </li>
              <li className="pt-2" data-id="element-98" data-mp="3dsqrm67a2zhq">
                <Link to="/policies/privacy" className="hover:text-secondary transition-colors" data-id="element-99" data-mp="38smbihaa86s1">
                  Privacy Policy
                </Link>
              </li>
              <li data-id="element-100" data-mp="3ip7ih85v3ryi">
                <Link to="/policies/terms" className="hover:text-secondary transition-colors" data-id="element-101" data-mp="3iopefpcyk9g1">
                  Terms & Conditions
                </Link>
              </li>
              <li data-id="element-102" data-mp="aa78bt6kv3z2">
                <Link to="/policies/cancellation" className="hover:text-secondary transition-colors" data-id="element-103" data-mp="aaqg4h2ikbzd">
                  Cancellation Policy
                </Link>
              </li>
              <li data-id="element-104" data-mp="jbevbf3n8idu">
                <Link to="/sitemap" className="hover:text-secondary transition-colors" data-id="element-105" data-mp="j8sppl0bccy9">
                  Sitemap
                </Link>
              </li>
            </ul>
          </div>
          {/* Contact */}
          <div className="lg:col-span-1" data-id="element-106" data-mp="12vm1t1scr0pl">
            <h3 className="font-serif text-xl font-bold mb-4" data-id="element-107" data-mp="12ub2be5xwf4a">Customer Care</h3>
            <div className="flex items-start mb-4" data-id="element-108" data-mp="owmgo441t3y6">
              <Mail className="h-5 w-5 mr-2 mt-0.5" data-id="element-109" data-mp="tvh6hq0fnsrs" />
              <div data-id="element-110" data-mp="ty3grxepkmdp">
                <p className="font-medium" data-id="element-111" data-mp="f72y6zk8zc3u">Email:</p>
                <a href="mailto:enquiries@medicolegal-psychiatry.co.uk" className="text-secondary hover:underline break-words" data-id="element-112" data-mp="f6b2zpukbge3">
                  enquiries@medicolegal-psychiatry.co.uk
                </a>
              </div>
            </div>
            <div className="mt-6" data-id="element-113" data-mp="a8t0ah751xej">
              <h4 className="font-medium mb-2" data-id="element-114" data-mp="a5nat0ulktia">Accreditations:</h4>
              <div className="flex flex-wrap gap-2" data-id="element-115" data-mp="3sexomto9y27r">
                <a href="https://www.medco.org.uk/" target="_blank" rel="noopener noreferrer" className="transition-opacity hover:opacity-80" data-id="element-116" data-mp="171xbk3zg4od">
                  <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/8X52QHFHr2pezRgSGP8PRu/Medco.png" alt="MedCo Accredited Medical Expert" className="h-8" loading="lazy" data-id="element-117" data-mp="1y4pofdp3apzf" />
                </a>
                <a href="https://www.gmc-uk.org/" target="_blank" rel="noopener noreferrer" className="transition-opacity hover:opacity-80" data-id="element-118" data-mp="2lubp65l41d9j">
                  <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/bdKLxaE25XhPcbz47Q5ek2/GMC.png" alt="General Medical Council (GMC) Registered" className="h-8" loading="lazy" data-id="element-119" data-mp="2csu2239acbbc" />
                </a>
                <a href="https://ico.org.uk/" target="_blank" rel="noopener noreferrer" className="transition-opacity hover:opacity-80" data-id="element-120" data-mp="wihydz79rm6i">
                  <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/oejz6MBWaYPHLboKrsxoJ8/ICO.png" alt="Information Commissioner's Office (ICO) Registered" className="h-8" loading="lazy" data-id="element-121" data-mp="waxu5kezj7bh" />
                </a>
                <a href="https://www.rcpsych.ac.uk/" target="_blank" rel="noopener noreferrer" className="transition-opacity hover:opacity-80" data-id="element-122" data-mp="1a1jbh4osj979">
                  <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/9akzzny18c2cokdDbeaSwa/RCPsych.png" alt="Professional psychiatric membership body logo" className="h-8" loading="lazy" data-id="element-123" data-mp="1jzqh4rdmq4ty" />
                </a>
                <a href="https://www.bondsolon.com/" target="_blank" rel="noopener noreferrer" className="transition-opacity hover:opacity-80" data-id="element-124" data-mp="1rhwxo7595r0g">
                  <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/r7LQZ1MUtT9MjPyaNm53VY/Bond_Solon.jpg" alt="Certified expert witness training provider logo" className="h-8" loading="lazy" data-id="element-125" data-mp="1waq5x4zxjhha" />
                </a>
                <a href="https://www.medschools.ac.uk/" target="_blank" rel="noopener noreferrer" className="transition-opacity hover:opacity-80" data-id="element-126" data-mp="1hltztdhfoejb">
                  <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/6MiZXdLANurvspjz8K3bmS/medical_school_council.png" alt="Medical School Council Recognised" className="h-8" loading="lazy" data-id="element-127" data-mp="2syxil96x2lj7" />
                </a>
              </div>
            </div>
          </div>
        </div>
        <div className="border-t border-white/20 mt-8 pt-6 text-center text-sm" data-id="element-128" data-mp="2mls7iqfokxd0">
          <p data-id="element-129" data-mp="2ris50cygsrsi">
            © {new Date().getFullYear()} Medicolegal Psychiatry. All rights
            reserved.
          </p>
          <button type="button" onClick={openCookiePreferences} className="mt-2 min-h-[44px] underline hover:text-secondary focus:outline-none focus-visible:ring-2 focus-visible:ring-secondary rounded" data-id="element-130" data-mp="3f9o3tu1c8n99">
            Cookie preferences
          </button>
        </div>
      </div>
    </footer>;
}